// src/store/widgetsSettings/index.js
import { createAsyncThunk, createReducer } from '@reduxjs/toolkit';
import { API } from '../../constants';
import { application } from '../../services/application';

export const INITIAL_STATE = {
  pending: false,
  error: null,

  // Normalized by subscription tier
  defaultWidgetsByTier: {
    pro: [],
    advantage: [],
    sapAdvantage: [],
    procurementPro: [],
    appMax: [],
  },
  widgetAccessByTier: {
    pro: [],
    advantage: [],
    sapAdvantage: [],
    procurementPro: [],
    appMax: [],
  },

  // Raw payload (optional, in case you need the exact keys)
  raw: {},
};

// NOTE: make sure this constant exists in your API map:
// API.GLOBAL_SETTINGS.GET_WIDGET_SETTINGS -> "admin.globalSettings.getWidgetSettings"
const getWidgetSettings = createAsyncThunk('widgets/getWidgetSettings', async (params) => {
  return application.call(API.WIDGET_SETTINGS.GET_WIDGET_SETTINGS, params);
});

function onGetWidgetSettings(state, action) {
  const payload = action.payload || {};
  const result = payload && payload.result ? payload.result : payload;

  const {
    defaultProWidgets = [],
    defaultAdvantageWidgets = [],
    defaultSapAdvantageWidgets = [],
    defaultProcurementProWidgets = [],
    defaultAppMaxWidgets = [],
    widgetAccessPro = [],
    widgetAccessAdvantage = [],
    widgetAccessSapAdvantage = [],
    widgetAccessProcurementPro = [],
    widgetAccessAppMax = [],
  } = result || {};

  Object.assign(state, {
    pending: false,
    error: null,
    raw: result || {},
    defaultWidgetsByTier: {
      pro: defaultProWidgets,
      advantage: defaultAdvantageWidgets,
      sapAdvantage: defaultSapAdvantageWidgets,
      procurementPro: defaultProcurementProWidgets,
      appMax: defaultAppMaxWidgets,
    },
    widgetAccessByTier: {
      pro: widgetAccessPro,
      advantage: widgetAccessAdvantage,
      sapAdvantage: widgetAccessSapAdvantage,
      procurementPro: widgetAccessProcurementPro,
      appMax: widgetAccessAppMax,
    },
  });
}

export const actions = {
  getWidgetSettings,
};

export default createReducer(INITIAL_STATE, (builder) => {
  builder
    .addCase(getWidgetSettings.pending, (state) => {
      state.pending = true;
      state.error = null;
    })
    .addCase(getWidgetSettings.fulfilled, onGetWidgetSettings)
    .addCase(getWidgetSettings.rejected, (state, action) => {
      state.pending = false;
      state.error = action.error?.message || 'Failed to load widget settings';
    });
});
